import React from "react";
import ContentLoader from "react-content-loader";

export default ({ times }) => (
  <ContentLoader
    height={500}
    width={400}
    speed={1}
    primaryColor="#d9d9d9"
    secondaryColor="#ecebeb"
  >
    <rect x="307" y="12" rx="2" ry="2" width="79" height="20" />
    <rect x="347" y="48" rx="2" ry="2" width="39" height="17" />
    <rect x="130" y="14" rx="2" ry="2" width="170" height="4" />
    <rect x="227" y="25" rx="2" ry="2" width="73" height="4" />
    <rect x="0" y="44" rx="2" ry="2" width="77" height="5" />
    <rect x="0" y="56" rx="2" ry="2" width="165" height="11" />
    <rect x="0" y="72" rx="2" ry="2" width="165" height="12" />
    <rect x="0" y="93" rx="2" ry="2" width="246" height="5" />
    <rect x="0" y="112" rx="2" ry="2" width="104" height="4" />
    <rect x="0" y="121" rx="2" ry="2" width="170" height="4" />
    <rect x="255" y="158" rx="2" ry="2" width="130" height="5" />
    <rect x="0" y="184" rx="2" ry="2" width="87" height="6" />
    <rect x="0" y="200" rx="2" ry="2" width="68" height="17" />
    <rect x="75" y="200" rx="2" ry="2" width="150" height="17" />
    <rect x="0" y="240" rx="2" ry="2" width="120" height="18" />
    <rect x="20" y="270" rx="2" ry="2" width="340" height="65" />
  </ContentLoader>
);
